import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { QuillEditorComponent } from 'ngx-quill';
//import Quill from 'quill';
import { NavigationEnd, Router } from '@angular/router';
import { BaseService } from '../../../core/services/api/base.service';
import { debounceTime, Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-dynamic-editor',
  templateUrl: './dynamic-editor.component.html',
  styleUrls: ['./dynamic-editor.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DynamicEditorComponent implements OnInit, OnDestroy {
  @Input() label: string;
  @Input() objectContent: any;
  @Input() configType: number = 1;
  @Input() placeholderdata?: string;
  @Input() isInvalid: boolean = false;
  @Input() showAsterisk: boolean = false;
  @Input() premiumMode: boolean = false;

  @Output() ContentModelChange = new EventEmitter<string>();

  htmlContent: any;

  quillConfig1 = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      //[{ header: 1 }, { header: 2 }], // custom button values
      [{ header: [1, 2, 3, 4, 5, 6, 1] }],
      [{ indent: '-1' }, { indent: '+1' }],
       [{ size: ['small', false, 'large', 'huge'] }], // outdent/indent
      //[{ direction: 'rtl' }], // text direction
      // custom dropdown
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],
      ['link'], // link and image, video
      ['clean'], // remove formatting button
    ],
  };

  quillConfig2 = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],
      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      [{ direction: 'rtl' }], // text direction
      [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ font: [] }],
      [{ align: [] }],
      ['clean'], // remove formatting button
      ['link', 'image', 'video'], // link and image, video
    ],
  };

  quillConfig3 = {
    toolbar: null,
  };

  textFormat: 'editor' | 'html' | 'text' = 'editor';
  saveSpinner = 'saveSpinner';
  isLoading = false;

  private modelChanged: Subject<void> = new Subject<void>();
  private subscription: Subscription;
  private readonly debounceTime = 3000;
  private hasPendingChanges = false;

  

  constructor(
    private router: Router,
    private baseService: BaseService,
    private el: ElementRef
  ) {}

  ngOnInit(): void {
    if (this.objectContent.endpoint) {
      console.log('editore with end piont');
      this.baseService.getApi(this.objectContent.endpoint).subscribe(
        (res) => {
          this.htmlContent = JSON.parse(JSON.stringify(res));
          console.log('getting html content ');
          console.log(res);
          console.log(this.htmlContent);
        },
        (error) => {}
      );
    }

    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        if (this.hasPendingChanges) {
          this.emitChange();
        }
      });
  }

  private emitChange(): void {
    this.hasPendingChanges = false;
    this.ContentModelChange.emit();
  }

  onBlur(): void {
    if (this.hasPendingChanges) {
      this.emitChange();
    }
  }

  setTextFormat(format: 'editor' | 'html'): void {
    if (this.textFormat === format) return;
    this.onBlur();
    this.textFormat = format;
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  setFocus(event) {
    event.focus();
  }
  
  /**
   * Strip HTML tags to get plain text
   */
  stripHtml(html: string = ''): string {
    return html.replace(/<[^>]*>/g, '');
  }

  onTextChange(event) {
    this.hasPendingChanges = true;
    this.modelChanged.next();
  }

  getQuillConfig() {
    switch (this.textFormat) {
      case 'text': {
        return this.quillConfig1;
      }
      case 'html': {
        return this.quillConfig3;
      }
      default: {
        return this.quillConfig1;
      }
    }

    /*switch (this.configType){
      case 1: {
        return this.quillConfig1;
      }
      case 2:{
        return this.quillConfig2;
        
      }
      default:{
        return "";
      }}*/
  }

  getFormat() {
    return this.textFormat;
  }

  saveHtmlContent() {
    console.log('on click save html');
    console.log(this.htmlContent);
    this.isLoading = true;
    this.baseService
      .putApiCall(this.objectContent.endpoint, this.htmlContent.html)
      .subscribe(
        (res) => {

          //TODO : EMIT EVENT TO SAVE THE TEMPLATE CONFIG.
          this.ContentModelChange.emit();
          //this.htmlContent = JSON.parse(JSON.stringify(res));
          console.log('saving html content ');
          console.log(res);
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
        }
      );
  }

  onChangeTextFormat(event) {
    console.log('on change text fomrat');
    this.textFormat = event.target.value;
    console.log(event);
    console.log(this.textFormat);
  }
}
